module.exports = __webpack_public_path__ + "static/media/分享投资相关内容.843ca17b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/分享投资相关内容.png
// module id = 1509
// module chunks = 0